import React from 'react';

import GameModeModal from '~/components/GameModesModals/GameModeModal';
import Icon from '~/components/Icon';

interface SingleplayerModeModalProps {
  onClose: () => void;
}

function SingleplayerModeModal({ onClose }: SingleplayerModeModalProps) {
  return (
    <GameModeModal
      dataCy="singleplayer-mode-modal"
      title="SINGLEPLAYER MODE"
      modeLabel="Singleplayer Mode"
      ctaTo="/arcade/config/singleplayer"
      onClose={onClose}
    >
      <div className="flex flex-col gap-2">
        <p className="mb-4">
          Master your gaming knowledge at your own pace with fully customizable
          challenges.
        </p>
        <div className="flex items-center gap-3">
          <Icon name="star" size={6} className="text-yellow-500" />
          <p>
            <span>Perfect your skills</span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="star" size={6} className="text-yellow-500" />
          <p>
            <span>Focus on your favorites</span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="star" size={6} className="text-yellow-500" />
          <p>
            <span>Test your knowledge across console generation</span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="star" size={6} className="text-yellow-500" />
          <p>
            <span>Relive gaming's golden eras</span>
          </p>
        </div>
      </div>

      <p>
        <span>
          Dive into immersive 360° panoramas, analyze strategic screenshots,
          decode iconic sound effects, and recognize gameplay videos from your
          favorite titles.
        </span>
      </p>
    </GameModeModal>
  );
}

export default SingleplayerModeModal;
